/**
 * Password validation utilities
 * Shared between API and Admin frontend
 */

const PASSWORD_MIN_LENGTH = 8;
const LETTER_REGEX = /[A-Za-z]/;
const NUMBER_REGEX = /\d/;
const PUNCTUATION_REGEX = /[^\w\s]/;

export const PASSWORD_REQUIREMENTS_MESSAGE =
  'Password must be at least 8 characters and include at least one letter, one number, and one punctuation character.';

/**
 * Validates password meets all requirements
 * @param password - Password to validate
 * @returns Error message if invalid, null if valid
 */
export const getPasswordValidationError = (password: string): string | null => {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return PASSWORD_REQUIREMENTS_MESSAGE;
  }

  if (!LETTER_REGEX.test(password)) {
    return PASSWORD_REQUIREMENTS_MESSAGE;
  }

  if (!NUMBER_REGEX.test(password)) {
    return PASSWORD_REQUIREMENTS_MESSAGE;
  }

  if (!PUNCTUATION_REGEX.test(password)) {
    return PASSWORD_REQUIREMENTS_MESSAGE;
  }

  return null;
};

/**
 * Check if password is valid
 * @param password - Password to check
 * @returns true if valid, false otherwise
 */
export const isValidPassword = (password: string): boolean => {
  return getPasswordValidationError(password) === null;
};

/**
 * Password requirements for display in UI
 */
export const PASSWORD_REQUIREMENTS = {
  minLength: PASSWORD_MIN_LENGTH,
  requiresLetter: true,
  requiresNumber: true,
  requiresPunctuation: true,
} as const;
